// import { rewardToWei } from "../../../utils"

const txObj = (address, args) => {
    args.from = address
    // gasPrice = (await avgGasPrice()) + 200000000000 // Added 200 gwei
    return args
}

// for contracts that use timestampLock send 0. For other contracts send null
const mintArtNFT = async (web3, abi, nftContractAddress, ownerAddress, tokenUri, setProcessing, setMessage, onSuccess) => {
    let nftContract
    // let stakingContract
    try {
        nftContract = new web3.eth.Contract(abi, nftContractAddress)
        // stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
    } catch (error) {
        setMessage("error", "Error initializing contract")
        console.log(error)
    }

    if (nftContract) {
        try {
            setProcessing(true)
            // let balanceInWei = await tokenContract.methods.balanceOf(ownerAddress).call()
            // let amountInWei = await web3.utils.toWei(currentPrice.toString(), "ether")
            // console.log("stake amount " + amountInWei)

            let args = { maxPriorityFeePerGas: 0, maxFeePerGas: 5000000, value: 10564900000000 }

            await nftContract.methods
                .mintNFT(tokenUri) // This contract receives amount and timestamplock, 0 if there is no blocking time
                .send(txObj(ownerAddress, args))
                .on("receipt", function (receipt) {
                    if (receipt.status === true) {
                        //  setAllowance(allowance - amount)
                        setProcessing(false)
                        setMessage("success", `NFT Minted successfully`)
                        onSuccess()
                    } else {
                        setMessage("error", "NFT Minting Fail")
                        setProcessing(false)
                    }
                })
                .on("error", function (error) {
                    setMessage("error", error.message)
                    setProcessing(false)
                })
            setProcessing(false)
        } catch (error) {
            console.log(error)
            setProcessing(false)
        }
    } else {
        setMessage("Uninitialized contracts")
    }
}

// // for contracts that use timestampLock send 0. For other contracts send null
// const unStakeNode = async (web3, pool, ownerAddress, tokenId, setProcessing, setMessage, onSuccess) => {
//     let tokenContract
//     let stakingContract
//     try {
//         stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
//     } catch (error) {
//         setMessage("error", "Error initializing contract")
//         console.log(error)
//     }

//     if (tokenId && stakingContract) {
//         try {
//             setProcessing(true)

//                     await stakingContract.methods
//                         .burnNFT(tokenId) // This contract receives amount and timestamplock, 0 if there is no blocking time
//                         .send(txObj(ownerAddress, pool.args))
//                         .on("receipt", function (receipt) {
//                             if (receipt.status === true) {
//                                 //  setAllowance(allowance - amount)
//                                 setProcessing(false)
//                                 setMessage("success", `Node Unstaked Successfully`)
//                                 onSuccess()
//                             } else {
//                                 setMessage("error", "Unstaking Fail")
//                                 setProcessing(false)
//                             }
//                         })
//                         .on("error", function (error) {
//                             setMessage("error", error.message)
//                             setProcessing(false)
//                         })
//                     setProcessing(false)

//         } catch (error) {
//             console.log(error)
//             setProcessing(false)
//         }
//     } else {
//         setMessage("Uninitialized contracts")
//     }

// }

export { mintArtNFT }
